import * as React from "react";

export const wrapInputInGroup = (input: JSX.Element) => {
  return <div className="input-group">{input}</div>;
};
